import { JSONSchema7 } from 'json-schema';

export const createPixelSchema = <
  E extends string,
  V extends string,
  D extends string,
  P extends Record<string, JSONSchema7>,
  R extends (keyof P)[],
>({
  event,
  description,
  version,
  properties,
  required,
}: {
  event: E;
  version: V;
  description: D;
  properties?: P;
  required?: R;
}) => {
  const baseSchemaProperties = {
    version: {
      $comment: 'Версия контракта',
      const: version,
    },
    event: {
      $comment: description,
      const: event,
    },
    source: {
      $comment: 'Источник события',
      const: 'polls',
    },
    referer: {
      $comment: 'URL исходной страницы',
      type: 'string',
      format: 'uri',
      examples: [
        'https://media.tinkoff.ru/polls/prod/poll-clo72blwh000s01kfcbde6789/index.html?attemptId=8261edf3-3247-49b2-8241-93cc986129d5',
      ],
    },
    quiz_id: {
      $comment: 'ID опроса',
      type: 'string',
      minLength: 25,
      maxLength: 25,
      examples: ['cl7yl0ca6001301kfcxacdu25'],
    },
    polls_ic: {
      $comment: 'IC сессии респондента',
      type: 'string',
      format: 'uuid',
      examples: ['ace1ddd6-b852-447a-a1df-560df6bca455'],
    },
    questions_count: {
      $comment: 'Количество вопросов',
      type: 'integer',
      minimum: 1,
      examples: [10],
    },
    revision: {
      $comment: 'Идентификатор ревизии опроса (инкрементируется при каждом сохранении опроса)',
      type: 'string',
      pattern: '^[1-9][0-9]*$',
      examples: ['26'],
    },
    wave: {
      $comment: 'Идентификатор волны опроса',
      type: 'string',
      pattern: '^[1-9][0-9]*$',
      examples: ['1'],
    },
  } as const;

  const requiredFields = [
    ...Object.keys(baseSchemaProperties),
    ...(required ?? []),
  ] as (keyof typeof baseSchemaProperties & R)[];

  return {
    $schema: 'http://json-schema.org/draft-07/schema#',
    type: 'object',
    additionalProperties: false,
    properties: { ...baseSchemaProperties, ...properties },
    required: requiredFields,
  } as const;
};
